import { useState } from 'react';
import Cookies from 'js-cookie';

export function useLocalStorage(key, initialValue) {

  const [storedValue, setStoredValue] = useState(() => {
    
    try {
      const item = window.localStorage.getItem(key);
      if (!item) {
        return initialValue;
      }

      const storedData = JSON.parse(item);
      const cookie = Cookies.get(key);
      if (!cookie) {
        window.localStorage.removeItem(key);
        return initialValue;
      }

      return storedData.value;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  });

  const setValue = value => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify({ value: valueToStore, timestamp: new Date().getTime() }));
      Cookies.set(key, 'valid', { expires: 1 });
    } catch (error) {
      console.error(error);
    }
  };

  return [storedValue, setValue];
}